import { normalize } from 'normalizr'

import * as api from 'api'
import * as schemas from 'api/schema'
import * as syncActions from 'actions/sync'
import * as selectors from 'reducers'

export const getEmailSubScription = () => (dispatch) => {
  const setEmailSubscription = (response) => {
    const normalizedData = normalize(response.data, schemas.emailSubscription)
    dispatch(
      syncActions.setEntities(normalizedData.entities, { emailSubscription: normalizedData.result })
    )
  }

  return api.getEmailSubscription().then(setEmailSubscription)
}

export const updateNotificationFrequency = (value) => (dispatch, getState) => {
  const state = getState()
  const emailSubscriptionId = selectors.getEmailSubscriptionId(state)
  const body = {
    notification_frequency: value,
  }

  return api
    .updateNotificationFrequency(emailSubscriptionId, body)
    .then((response) => {
      dispatch(syncActions.setEmailSubscription(response.data))
      return response.data
    })
    .catch(async (error) => {
      console.error('Failed during "setNotificationFrequency" action', error)
      return error
    })
}

export const updateEmailSurveySubscription = (id, value) => (dispatch) => {
  return api
    .updateEmailSurveySubscription(id, value)
    .then((data) => {
      dispatch(syncActions.setEmailSurveySubscription(data))
    })
    .catch((error) => {
      console.error('[Action](updateEmailSurveySubscription) Failed to run', error)
      throw error
    })
}



// WEBPACK FOOTER //
// ./node_modules/eslint-loader??ref--0-0!./src/actions/async/profile.js